import { Typography } from '@mui/material'
import FormattedAgentText from '../FormattedAgentText'
import StreamingText from '../StreamingText'

const VARIANT_SX = {
  default: {
    fontSize: 'var(--app-agent-result-font-size, 13px)',
    fontWeight: 'var(--app-agent-result-font-weight)',
  },
  emphasis: {
    fontSize: 'var(--app-agent-result-font-size, 13px)',
    fontWeight: 'var(--app-agent-result-font-weight-medium)',
  },
}

const BulletedList = ({ items, streaming = false, variant = 'default' }) => {
  const text = (items ?? []).join('\n')
  const sx = {
    m: 0,
    my: '8px',
    color: 'text.primary',
    fontFamily: 'inherit',
    lineHeight: 'var(--app-agent-result-line-height, 1.2)',
    whiteSpace: 'pre-wrap',
    ...(VARIANT_SX[variant] ?? VARIANT_SX.default),
  }

  if (streaming) {
    return (
      <Typography component="p" variant="body2" sx={{ ...sx }} aria-busy="true">
        <StreamingText component="span" text={text} showCaret formatted streaming />
      </Typography>
    )
  }

  if (!items?.length) return null

  return (
    <Typography component="p" variant="body2" sx={sx}>
      <FormattedAgentText text={text} />
    </Typography>
  )
}

export default BulletedList
